import { Input, Modal, Spin } from "antd"
import { useContext } from "react"
import GeneralContext from '../../context/GeneralContext/GeneralContext'
import { displayMessage } from '../../services/helper'

const RecoverPassword = ({ isModalRecoverPasswordOpen, handleOnCloseModalRecoverPassword, handleOnOkRecoverPassword, email, setEmail}) => {

    const {
        showLoading
    } = useContext(GeneralContext)

    return (
        <>
        <Modal
            title={displayMessage('RECOVER_PASSWORD')}
            visible={isModalRecoverPasswordOpen}
            onCancel={handleOnCloseModalRecoverPassword}
            onOk={handleOnOkRecoverPassword}
            centered={true}
        >
            <div className="flex flex-row justify-center">
                {showLoading ?
                    <Spin tip={displayMessage('WAITING')} />
                    :
                    <div className="flex flex-col flex-1 text-sm">
                        <div className="mr-10 font-bold">{displayMessage('DISPLAY_REGISTERED_EMAIL')}:</div>
                        <Input
                            type="text"
                            value={email}
                            required={true}
                            onChange={
                                e => {
                                    setEmail(e.target.value)
                                }
                            }
                        />
                    </div>
                }
            </div>
        </Modal>
    </>
    )
}

export default RecoverPassword